// @ts-nocheck

export function sendMessage(ws, data) {
  ws.send(JSON.stringify(data));
}

export function sendError(ws, error) {
  console.error('websocket:error', error);
  sendMessage(ws, { cmd: 'error', error });
}
